import { createContext } from "react";
var SpaShellContext = createContext(false);
export {
  SpaShellContext
};
//# sourceMappingURL=SpaShellContext.js.map
